var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.575 97v-5.763m0-5.696v-5.763m0-5.695V68.32m0-5.696v-5.763m0-5.695v-5.764m17.852-1.136c-2.8-3.994-1.817-9.553 2.179-12.352L76.176 4.178C72.18 6.976 66.618 5.994 63.818 2L4.178 43.74c2.8 3.994 1.818 9.553-2.178 12.352l10.414 15.296m59.245-25.873-3.306-4.722m-3.271-4.666-3.307-4.722m-3.268-4.662-3.306-4.722m-3.27-4.666-3.307-4.722M28 45.17l-1.403-6.252 9.943 6.367 9.975-5.722-1.264 5.417M21.32 97h72.806c0-4.879 3.993-8.87 8.874-8.87V54.272c-4.881 0-8.874-3.99-8.874-8.87H21.32c0 4.88-3.993 8.87-8.874 8.87V88.13c4.881 0 8.874 3.991 8.874 8.87Zm23.835-40.947 4.49 10.917L61.1 68.003l-8.678 7.781 2.587 11.556-9.854-6.11-9.854 6.11 2.587-11.556-8.68-7.781 11.456-1.033 4.49-10.917Z",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesUpload);
export default __webpack_public_path__ + "static/media/features-upload.52a7d52b1f1367c0c05496b2c7fd5225.svg";
export { ForwardRef as ReactComponent };